// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3F6cF","text":"styles_text__wirHK","list":"styles_list__wabJu"};